import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { ligarRegistroDeErros } from './core/registro'

ligarRegistroDeErros()

// Desktop: janela aberta para UM arquivo (apps/desktop/src/main.rs, rótulo
// "arquivo-N") mostra só o Quick View. O App inteiro é carregado sob demanda
// para que essa janela nem importe o core/vault — importá-lo liga o sync.
const rotuloDaJanela = (
  window as unknown as { __TAURI_INTERNALS__?: { metadata?: { currentWindow?: { label?: string } } } }
).__TAURI_INTERNALS__?.metadata?.currentWindow?.label
const raiz = createRoot(document.getElementById('root')!)
if (rotuloDaJanela?.startsWith('arquivo-')) {
  void import('./app/JanelaArquivo').then(({ JanelaArquivo }) =>
    raiz.render(
      <StrictMode>
        <JanelaArquivo />
      </StrictMode>,
    ),
  )
} else {
  void import('./app/App.tsx').then(({ default: App }) =>
    raiz.render(
      <StrictMode>
        <App />
      </StrictMode>,
    ),
  )
}

// Service Worker: PWA instalável + cache offline básico (sinapse-projeto.md §3.5, Fase 1.2).
// No DESKTOP (Tauri) os assets já vêm do protocolo embutido (custom-protocol), então
// o SW não ajuda e ainda quebra o carregamento no webview (tela branca após atualizar
// o build). Por isso: registra só na web/PWA de produção; no Tauri, remove SWs antigos.
const isTauri = '__TAURI_INTERNALS__' in window || '__TAURI__' in window
if ('serviceWorker' in navigator) {
  if (isTauri) {
    navigator.serviceWorker
      .getRegistrations()
      .then((rs) => rs.forEach((r) => r.unregister()))
      .catch(() => {})
    if ('caches' in window) {
      caches.keys().then((ks) => ks.forEach((k) => caches.delete(k))).catch(() => {})
    }
  } else if (import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => {})
    })
  }
}
